export default "__VITE_ASSET__10cccb39__"